// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"SetAccountPasswordForm__loginForm__3Vb35","alertsMb":"SetAccountPasswordForm__alertsMb__2j95L","submitButton":"SetAccountPasswordForm__submitButton__2x3oi","paragraph":"SetAccountPasswordForm__paragraph__2QqG5","headline":"SetAccountPasswordForm__headline__1l1ID"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SetAccountPasswordForm/SetAccountPasswordForm.css
// module id = 1037
// module chunks = 0